// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryColor": `#d8c17a`,
	"secondaryColor": `#111`,
	"textColorPrimary": `rgba(255,255,255,.9)`,
	"textColorSecondary": `rgba(255,255,255,.6)`,
	"textColorDark": `rgba(0,0,0,.8)`,
	"slideDark": `#111`
};
export default ___CSS_LOADER_EXPORT___;
